var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatutVertMisEnLigne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,16.2H2.6V3.6h18.8 M21.4,1.5H2.6c-1.1,0-2.1,0.9-2.1,2.1c0,0,0,0,0,0v12.5c0,1.2,0.9,2.1,2.1,2.1l0,0h7.3v2.1H7.8v2.1 h8.4v-2.1h-2.1v-2.1h7.3c1.2,0,2.1-0.9,2.1-2.1l0,0V3.6C23.5,2.5,22.6,1.5,21.4,1.5C21.4,1.5,21.4,1.5,21.4,1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3,6.8l-8.4,8.4L6,11.3l1-1l2.9,2.8l7.4-7.4L18.3,6.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutVertMisEnLigne);
export default __webpack_public_path__ + "static/media/statut_vert_mis-en-ligne.3b7a0c72.svg";
export { ForwardRef as ReactComponent };